export const COOKIE_NAME = "app_session_id";
export const ONE_YEAR_MS = 1000 * 60 * 60 * 24 * 365;
export const AXIOS_TIMEOUT_MS = 30_000;
export const UNAUTHED_ERR_MSG = 'Please login (10001)';
export const NOT_ADMIN_ERR_MSG = 'You do not have required permission (10002)';

// ─── Solutions catalog: shared settings keys & defaults ─────────────────────
export const SETTING_AUDIT_PRICE = "audit_price";          // whole AUD dollars, e.g. "3300"
export const SETTING_AUDIT_NAME = "audit_name";            // e.g. "Practice Growth Audit"
export const SETTING_AUDIT_DESCRIPTION = "audit_description";
export const SETTING_GUARANTEE_TITLE = "guarantee_title";  // e.g. "Our 90-day guarantee"
export const SETTING_GUARANTEE_TEXT = "guarantee_text";

export const CATALOG_SETTING_KEYS = [
  SETTING_AUDIT_PRICE,
  SETTING_AUDIT_NAME,
  SETTING_AUDIT_DESCRIPTION,
  SETTING_GUARANTEE_TITLE,
  SETTING_GUARANTEE_TEXT,
] as const;

export const TIER_KEYS = ["starter", "growth", "scale"] as const;
export type TierKey = (typeof TIER_KEYS)[number];
